import './PlayerHand.css';

import {useTypedSelector} from "../../../../hooks/useTypedSelector";
import {isMobile} from 'react-device-detect';
import PlayerHandCard from "./PlayerHandCard";


function PlayerHand() {

    const {playerHand} = useTypedSelector(state => state.game);

    let itemCount = 0;
    Object.keys(playerHand).map((item, index) => {
        itemCount++;
    })

    let y = 25;

    if(isMobile){
        y = 15;
    }

    const mapPositions = {
        1: {0: {x: 0, y: -y, rotate: 0}},
        2: {0: {x: 0, y: -y, rotate: -0.5}, 1: {x: 0, y: -y, rotate: 0.5}},
        3: {0: {x: 0, y: -y + 5, rotate: -0.5}, 1: {x: 0, y: -y, rotate: 0}, 2: {x: 0, y: -y + 5, rotate: 0.5}},
        4: {
            0: {x: 0, y: -y + 5, rotate: -1},
            1: {x: 0, y: -y, rotate: -0.5},
            2: {x: 0, y: -y, rotate: 0.5},
            3: {x: 0, y: -y + 5, rotate: 1}
        },
        5: {
            0: {x: 0, y: -y + 10, rotate: -1},
            1: {x: 0, y: -y + 5, rotate: -0.5},
            2: {x: 0, y: -y, rotate: 0},
            3: {x: 0, y: -y + 5, rotate: 0.5},
            4: {x: 0, y: -y + 10, rotate: 1}
        },
        6: {
            0: {x: 0, y: -y + 10, rotate: -1.5},
            1: {x: 0, y: -y + 5, rotate: -1},
            2: {x: 0, y: -y, rotate: -0.5},
            3: {x: 0, y: -y, rotate: 0.5},
            4: {x: 0, y: -y + 5, rotate: 1},
            5: {x: 0, y: -y + 10, rotate: 1.5}
        },
        7: {
            0: {x: 0, y: -y + 15, rotate: -1.5},
            1: {x: 0, y: -y + 10, rotate: -1},
            2: {x: 0, y: -y + 5, rotate: -0.5},
            3: {x: 0, y: -y, rotate: 0},
            4: {x: 0, y: -y + 5, rotate: 0.5},
            5: {x: 0, y: -y + 10, rotate: 1},
            6: {x: 0, y: -y + 15, rotate: 1.5}
        },
    };

    return (
        <div className="playerHand">
            {Object.keys(playerHand).map((item, index) => {

                const position = mapPositions[itemCount][index];
                const transformItem = {
                    transform: 'translate( -7px, ' + position.y + 'px) rotate(' + position.rotate + 'deg)'
                };

                return <div key={'hand_container_' + index} className={"playerHandItem "} style={transformItem}>
                    <PlayerHandCard key={'hand_' + index} card={playerHand[item]} handKey={item}/>
                </div>
            })}
        </div>
    );
}

export default PlayerHand;